module.exports = __webpack_public_path__ + "c23eac4b305c26cf6220b02e3703e15a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/cat.svg
// module id = 82
// module chunks = 0